import { EventEmitter } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../../environments/environment';
import { Globals } from './../globals';
import { Observer } from 'rxjs';

export class SocketService {
    readonly url = environment.socketURL;
    callUser: EventEmitter<any> = new EventEmitter();
    private socket;

    constructor() {
      if(Globals["socket"]){
        this.socket = Globals["socket"];
      } else {
        var token = localStorage.getItem('token');
        this.socket = io(this.url, {transports: ['websocket', 'polling', 'flashsocket'], query:{token:token}});
        Globals["socket"] = this.socket;
      }

      this.socket.on('load:users', function(data) {
        var onlineUsers = {};
        if(data.success){
          for(var i in data.users){
            onlineUsers[data.users[i].id] = data.users[i];
          }
        }
        Globals["onlineUsers"] = onlineUsers;
      });
    }

    public disconnect() {
      this.socket.disconnect();
      Globals["socket"] = null;
    }

    public youCallUser(data) {
      this.socket.emit('call:user', data);
    }

    public userCallYou = () => {
        return Observable.create((observer) => {
            this.socket.on('call:user', (data) => {
                observer.next(data);
            });
        });
    }

    public youAnswerCall(data) {
      this.socket.emit('answer:user', data);
    }

    public userAnswerCall = () => {
        return Observable.create((observer) => {
            this.socket.on('answer:user', (data) => {
                observer.next(data);
            });
        });
    }

    public sendOffer(data) {
      this.socket.emit('offer', data);
    }

    public onOffer = () => {
        return Observable.create((observer) => {
            this.socket.on('offer', (data) => {
                observer.next(data);
            });
        });
    }

    public sendAnswer(data) {
      this.socket.emit('answer', data);
    }

    public onAnswer = () => {
        return Observable.create((observer) => {
            this.socket.on('answer', (data) => {
                observer.next(data);
            });
        });
    }

    public sendCandidate(data) {
      this.socket.emit('candidate', data);
    }

    public onCandidate = () => {
        return Observable.create((observer) => {
            this.socket.on('candidate', (data) => {
                observer.next(data);
            });
        });
    }

    public hangup(data) {
      this.socket.emit('hangup', data);
    }

    public onHangUp = () => {
        return Observable.create((observer) => {
            this.socket.on('hangup', (data) => {
                observer.next(data);
            });
        });
    }

    public onMessage = () => {
        return Observable.create((observer) => {
            this.socket.on('message', (data) => {
                observer.next(data);
            });
        });
    }

    public onNotification = () =>{
      return Observable.create((observer:Observer<any>)=>{
        this.socket.emit('notification:list')
        observer.complete();
      })
    }

    public onGetNotification =() =>{
      return Observable.create((observer) => {
        this.socket.on("notifications:get", (data) => {
          observer.next(data);
        })
      })
    }

    public onReadNotification = (notification) =>{
      this.socket.emit('notification:read', notification, function(data){
      })
    }

    public sendMessage(toId, content, type, callback) {
      var data = {type:type?type:"text", id:toId};
      if(data.type == "voice") {
        data["audio"] = content;
      } else {
        data["description"] = content;
      }
      this.socket.emit('message', data, callback);
    }

    public onRecieveNotification(){
      return Observable.create((observer) => {
        this.socket.on('notification:send', (data) => {
          observer.next(data);
        })
    })
  }

    public getVoiceMessage(id, callback) {
      this.socket.emit('voice:message', id, function(data){
        callback(new Blob([new Uint8Array(data)], { 'type' : 'audio/ogg; codecs=opus' }));
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/socket/socket-service.ts